module.exports = __webpack_public_path__ + "img/share_story.883b22fb.jpg";